export default (props, vars) => 'current';
